<template>
    <div class="reports-info">
        <Loading v-if="isLoadingScreen" />
        <template v-else>
            <div class="reports-info__form-search">
                <div class="input-group-main">
                    <label>{{ getTranslatedText('Product') }}:</label>
                    <div class="input-group-select">
                        <Select :items="products" v-model="product" :isRenderCustom="true" />
                    </div>
                </div>
                <div class="input-group-main">
                    <label>{{ getTranslatedText('game type') }}:</label>
                    <div class="input-group-select">
                        <Select :items="betType" v-model="bet" :isRenderCustom="true" />
                    </div>
                </div>
                <div class="input-group-main column-mb" v-if="type === 'weekly'">
                    <label>{{ getTranslatedText('date') }}:</label>
                    <div class="input-group-select combobox">
                        <v-combobox variant="outlined" v-model="modelDateWeekly" :items="dateWeekLy" item-value="key" item-text="value" @input.native="handleComboboxInput"></v-combobox>
                    </div>
                </div>
                <div v-else class="reports-info__form-search__date" :class="type === 'weekly' ? 'date-weekly' : ''">
                    <label>{{ getTranslatedText('date') }}:</label>
                    <div class="date-group">
                        <div class="date">
                            <DatePicker @input="(value) => onChangeDate(value)" />
                        </div>
                    </div>
                </div>
                <div class="box-btn">
                    <ButtonCommon :is-disable="isCheckDisbelBtnSearch" :isLoading="isLoadingFilter" text="Submit" class-name="submit-btn" :isNoHover="true" @action-button="onSubmitSearch" />
                </div>
            </div>
            <div class="reports-info__detail">
                <Loading v-if="isLoadingFilter" />
                <div class="reports__content--empty" v-else-if="!dataReports">
                    <p>{{ getTranslatedText('your reports is empty') }}</p>
                </div>
                <template v-else>
                    <p class="reports-info__detail__title">{{ type === 'daily' ? getTranslatedText('Daily Sales Report') : getTranslatedText('Weekly Sales Report') }}</p>
                    <div v-if="type === 'weekly'" class="reports-info__detail__date header-date">
                        <p class="text-date">
                            {{ getTranslatedText('Week start date: ') }}<span class="date-from">{{ renderDateWeekly(renderValueDateWeekly, true, true) }}</span>
                        </p>
                        <div class="text-date">
                            {{ getTranslatedText('Week end date: ') }}<span class="date-to">{{ renderDateWeekly(renderValueDateWeekly, false, true) }}</span>
                        </div>
                    </div>
                    <div class="second-date">
                        <p class="text">{{ type === 'daily' ? renderDateFrom : dateJoin }}</p>
                        <p class="text">{{ timeJoin }}</p>
                        <p class="text up" v-show="!$store.state.isScreenMobile">{{ getTranslatedText('POS ID: ') + renderSerialNumber() }}</p>
                    </div>
                    <p class="text up" v-show="$store.state.isScreenMobile">{{ getTranslatedText('POS ID: ') + renderSerialNumber() }}</p>
                    <div class="reports-info__detail__date text-user">
                        <p class="text-date">
                            <span>{{ getTranslatedText('Retailer Name') }}</span
                            ><span>{{ dataReports.branch_name }}</span>
                        </p>
                        <p class="text-date">
                            <span
                                >{{ getTranslatedText('Retailer') + ' ' }}<span>{{ getTranslatedText('BRN') }}:</span></span
                            >
                            <span>{{ dataReports.brn_num }}</span>
                        </p>
                    </div>
                    <div class="resport-info__detail-list">
                        <div class="resport-info__detail-item" v-for="(item, key) in dataReports.details" :key="key">
                            <p class="text-date">{{ getTranslatedText(key) }}</p>
                            <div class="third-content">
                                <div class="third-content__info" v-for="(obj, index) in item" :key="index">
                                    <p class="text">{{ obj.game_name }}</p>
                                    <p class="text">{{ obj.sales_count }}</p>
                                    <p class="text">{{ CURRENCY + '. ' + renderPrice(obj.sales_amount) }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="summary">
                        <p class="text-date">{{ getTranslatedText('summary') }}</p>
                        <div class="summary__content">
                            <p class="text">
                                <span>{{ getTranslatedText('Total Sales:') }}</span>
                                <span>{{ CURRENCY + '. ' + renderPrice(dataReports.total_sales) }}</span>
                            </p>
                            <p class="text">
                                <span>{{ getTranslatedText('Total Payouts:') }}</span>
                                <span>{{ CURRENCY + '. ' + renderPrice(dataReports.total_payouts) }}</span>
                            </p>
                            <p class="text">
                                <span>{{ getTranslatedText('Total Cancellations:') }}</span>
                                <span>{{ CURRENCY + '. ' + renderPrice(dataReports.total_cancellation) }}</span>
                            </p>
                            <p v-if="type === 'daily'" class="text">
                                <span>{{ getTranslatedText('Balance:') }}</span>
                                <span>{{ CURRENCY + '. ' + renderPrice(dataReports.balance) }}</span>
                            </p>
                        </div>
                    </div>
                    <div class="text_footer" v-if="type === 'daily'">
                        <p>
                            <span>{{ getTranslatedText('Total Sales Commission') }}</span
                            ><span>{{ CURRENCY + '. ' + renderPrice(dataReports.total_sales_commission) }}</span>
                        </p>
                        <p>
                            <span>{{ getTranslatedText('Total Payout Commission') }}</span
                            ><span>{{ CURRENCY + '. ' + renderPrice(dataReports.total_payouts_commission) }}</span>
                        </p>
                        <p>
                            <span>{{ getTranslatedText('Total Value Commission') }}</span
                            ><span>{{ CURRENCY + '. ' + renderPrice(dataReports.hotpick_comm_amount) }}</span>
                        </p>
                    </div>

                    <template v-if="type === 'weekly'">
                        <div class="text_footer">
                            <p>
                                <b>{{ getTranslatedText('NET DUE') }} </b>
                            </p>
                            <br />
                            <p>
                                <span>{{ getTranslatedText('TRADITIONAL LOTTERY CHANNEL (EXCL TAX ON COMM)') }}</span>
                                <span>{{ CURRENCY + '. ' + renderPrice(dataReports.traditional_lottery_no_comm_tax_net_due_amount) }}</span>
                            </p>
                            <p>
                                <span>{{ getTranslatedText('HOTPICKS CHANNEL (EXCL TAX ON COMM)') }}</span>
                                <span>{{ CURRENCY + '. ' + renderPrice(dataReports.hotpick_no_comm_tax_net_due_amount) }}</span>
                            </p>
                            <p>
                                <span>{{ getTranslatedText('TOTAL TAX ON COMMISSION') }}</span>
                                <span>{{ CURRENCY + '. ' + renderPrice(dataReports.total_tax_on_comm_amount) }}</span>
                            </p>
                            <br />
                            <p>
                                <span>{{ getTranslatedText('TOTAL NET DUE') }}</span>
                                <span>{{ CURRENCY + '. ' + renderPrice(dataReports.total_net_due_amount) }}</span>
                            </p>
                        </div>
                        <div class="text_footer">
                            <p class="text-date">{{ getTranslatedText('COMMISSION') }}</p>
                            <p>
                                <span>{{ getTranslatedText('COMM ON HOTPICKS CHANNEL') }}</span>
                                <span>{{ CURRENCY + '. ' + renderPrice(dataReports.hotpick_comm_amount) }}</span>
                            </p>
                            <p>
                                <span>{{ getTranslatedText('COMM ON TRADITIONAL LOTTERY CHANNEL') }}</span>
                                <span>{{ CURRENCY + '. ' + renderPrice(dataReports.traditional_lottery_comm_amount) }}</span>
                            </p>
                            <p>
                                <span>{{ getTranslatedText('TOTAL COMMISSION') }}</span>
                                <span>{{ CURRENCY + '. ' + renderPrice(dataReports.total_comm_amount) }}</span>
                            </p>
                            <p>
                                <span>{{ getTranslatedText('TOTAL TAX ON COMMISSION') }}</span>
                                <span>{{ CURRENCY + '. ' + renderPrice(dataReports.total_tax_on_comm_amount) }}</span>
                            </p>
                            <br />
                            <p>
                                <span>{{ getTranslatedText('COMM WITHOUT VAT') }}</span>
                                <span>{{ CURRENCY + '. ' + renderPrice(dataReports.comm_no_vat_amount) }}</span>
                            </p>
                            <p>
                                <span>{{ getTranslatedText('VAT ON COMM') }}</span>
                                <span>{{ CURRENCY + '. ' + renderPrice(dataReports.vat_on_comm_amount) }}</span>
                            </p>
                            <p>
                                <span>{{ getTranslatedText('COMM WITH VAT') }}</span>
                                <span>{{ CURRENCY + '. ' + renderPrice(dataReports.comm_with_vat_amount) }}</span>
                            </p>
                        </div>
                    </template>
                    <div class="box-btn">
                        <ButtonCommon text="Print" class-name="print-btn" :isNoHover="true" @action-button="onPrintClicked" />
                    </div>
                </template>
            </div>
        </template>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language/language-mixins'
import errorDeviceMinxins from "@/mixins/errorDevice/errorDevice-mixins";
import getSrvTime from "@/mixins/getSrvTime/getSrvTime-mixins";
import printMixins from "@/mixins/print/print-mixins";
import ButtonCommon from '@/components/common/button'
import DatePicker from '@/components/common/datepicker'
import Select from '@/components/common/select'
import { formatDate, formatPrice, getAllFirstDate, addDaysToDate, getSettingDevice, groupByItem, isArrayEmpty, isStrEmpty, isObjEmpty } from '@/utils/utils'
import Loading from '@/components/common/loading'
import ReportService from '@/services/report.service'
import EventBus from '@/utils/EventBus'
const CURRENCY_SYMBOL = process.env.VUE_APP_CURRENCY_SYMBOL
const TIME_ZONE = process.env.VUE_APP_TIME_ZONE

export default {
    mixins: [languageMixins, errorDeviceMinxins, printMixins, getSrvTime],
    components: { ButtonCommon, DatePicker, Select, Loading },
    props: {
        type: {
            type: String,
            default: 'daily',
        },
    },
    data() {
        return {
            currentDate: this.srvTime(),
            tab: null,
            dataReports: null,
            valueCombox: '',
            modelDateWeekly: '',
            renderValueDateWeekly: '',
            valueDateWeekly: '',
            dateWeekLy: [],
            product: '',
            products: [],
            bet: '',
            betType: [],
            printData: null,
            isLoadingScreen: true,
            isLoadingFilter: false,
            isCheckDisbelBtnSearch: true,
            CURRENCY:this.$store.state.configAccount?.settings.CURRENCY_SYMBOL ? this.$store.state.configAccount?.settings.CURRENCY_SYMBOL : CURRENCY_SYMBOL,
            dateFrom: '',
            renderDateFrom: '',
            dateJoin: '',
            dateJoinTime: '',
            dataDetails:''
        }
    },
    watch: {
        product(newValue) {
            let betType = [
                {
                    key: '',
                    value: this.getTranslatedText('seleted game type'),
                },
            ]
            if (!isStrEmpty(newValue)) {
                this.isCheckDisbelBtnSearch = false
                this.dataDetails[newValue]?.forEach((e) => {
                    let itemBettype = {
                        key: e?.game_type,
                        value: e?.game_name
                    }
                    betType.push(itemBettype)
                })
            }
            this.betType = betType;
            this.bet = '';

        },
        bet(newValue) {
            if (!isStrEmpty(newValue)) {
                this.isCheckDisbelBtnSearch = false
            }
        },
        modelDateWeekly(newValue) {
            if (newValue['key'] && !isStrEmpty(newValue['key'])) {
                this.isCheckDisbelBtnSearch = false
                this.valueCombox = newValue
            }
        },
    },
    created() {
        this.fetchDataReports();
    },
    destroyed() {},

    methods: {
        onSubmitSearch() {
            if (this.type === 'weekly') {
                if (!isObjEmpty(this.valueCombox)) {
                    this.renderValueDateWeekly = this.valueCombox.key
                    this.valueDateWeekly = this.valueCombox.key
                } else if (isObjEmpty(this.valueCombox) && isStrEmpty(this.valueCombox)) {
                    this.valueDateWeekly = this.dateWeekLy[0].key
                    this.renderValueDateWeekly = this.dateWeekLy[0].key
                    this.valueCombox = this.dateWeekLy[0]
                } else {
                    this.valueDateWeekly = ''
                }
            } else {
                if (isStrEmpty(this.dateFrom)) {
                    const dateFormat = formatDate(this.$helpers.changeTimeZone(this.currentDate,TIME_ZONE))
                    this.dateFrom = `${dateFormat.year}-${dateFormat.month}-${dateFormat.day}`
                    this.renderDateFrom = `${dateFormat.day}-${dateFormat.month}-${dateFormat.year}`
                } else {
                    this.renderDateFrom = this.$helpers.formatDate(this.dateFrom)
                }
            }
            this.fetchDataReports(true)
        },
        async onPrintClicked() {
            if (!this.printData || this.printData.trim() === '') {
                return
            }
            let printData = await this.prepareLogoAsSingleObject(this.printData)

            // print only, missing other UI/UX flow
            parent.postMessage({ command: 'print-report', data: printData, defaultSunmiFont: this.$store.state.configAccount?.sunmiPrinterFont }, '*')
        },

        handleComboboxInput(event) {
            const { value } = event.target
            this.valueCombox = value
        },

        async fetchDataReports(isFilter = false) {
            const param = {
                title: '',
                status: "error",
            };
            try {
                this.isLoadingFilter = isFilter
                if((this.product || this.bet)){
                    isFilter = true
                }
                let isDaily = this.type === 'daily'

              const dateFormat = formatDate(this.$helpers.changeTimeZone(this.currentDate,TIME_ZONE))

              if (!isDaily && !isFilter && isArrayEmpty(this.dateWeekLy)) {
                    let dateWeekLy = [];
                    const resListWeeks = await ReportService.getListWeeks();
                    if (resListWeeks.status === 'success') {

                        dateWeekLy = resListWeeks.data.map((item) => ({
                            value: item?.label,
                            key: `${item?.from}vs${item?.to}`
                        }))
                        this.dateWeekLy = dateWeekLy;
                    }

                    this.valueDateWeekly = dateWeekLy[0].key
                    this.renderValueDateWeekly = dateWeekLy[0].key
                    this.modelDateWeekly = dateWeekLy[0]
                    this.dateWeekLy = dateWeekLy
                }

                let resp
                if (isDaily) {
                    let dateFrom = isFilter ? this.dateFrom : `${dateFormat.year}-${dateFormat.month}-${dateFormat.day}`
                    resp = await ReportService.getDailySalesReport(dateFrom, this.bet, this.product)
                } else {
                    let dateWeekLyFrom = this.renderDateWeekly(this.valueDateWeekly, true)
                    let dateWeekLyTo = this.renderDateWeekly(this.valueDateWeekly, false)

                    resp = await ReportService.getWeeklySalesReport(dateWeekLyFrom, dateWeekLyTo, this.bet, this.product)
                }

                if (resp.status === 'success') {
                    let details = groupByItem(resp.data.details, 'product')
                    resp.data['details'] = details
                    this.dataReports = resp.data
                    if (!isFilter) {
                        this.dataDetails = details;
                        let products = [
                            {
                                key: '',
                                value: this.getTranslatedText('seleted product'),
                            },
                        ]
                        let betType = [
                            {
                                key: '',
                                value: this.getTranslatedText('seleted game type'),
                            },
                        ]
                        for (let key in details) {
                            if (details.hasOwnProperty(key)) {
                                let itemProduct = {
                                    key,
                                    value: this.getTranslatedText(key),
                                }
                                products.push(itemProduct)
                            }
                        }
                        let today = `${dateFormat.day}-${dateFormat.month}-${dateFormat.year}`
                        this.products = products
                        this.betType = betType
                        this.dateFrom = `${dateFormat.year}-${dateFormat.month}-${dateFormat.day}`
                        this.renderDateFrom = today
                        this.dateJoin = today
                        this.timeJoin = `${dateFormat.hour24h}:${dateFormat.minutes}:${dateFormat.seconds}`
                    }

                    this.printData = resp.data.printData
                    this.isLoadingScreen = false
                    this.isLoadingFilter = false
                } else {
                    this.dataReports = null
                    this.isLoadingScreen = false
                    this.isLoadingFilter = false
                    param.title = resp.data?.errors
                    ? resp.data.errors.map(item => item.message).join(', ')
                    : resp.message;
                    EventBus.$emit("on-show-notications", param)
                }
                this.checkErrorDevice(this.$router, resp)
            } catch (error) {
                this.dataReports = null
                this.isLoadingFilter = false
                this.isLoadingScreen = false
                param.title = error.data?.errors
                ? error.data.errors.map(item => item.message).join(', ')
                : error.message;
                console.log(error)
                EventBus.$emit("on-show-notications", param)
                this.checkErrorDevice(this.$router, error)
            }
        },

        onChangeDate(date) {
            this.dateFrom = date
            this.isCheckDisbelBtnSearch = false
        },

        renderDate(date, isShowHour) {
            const dateFormat = formatDate(this.$helpers.changeTimeZone(new Date(date),TIME_ZONE))

            let valueDate = isShowHour ? `${dateFormat.hours}:${dateFormat.minutes}:${dateFormat.seconds}` : this.$helpers.formatDate(date)

            return valueDate
        },

        renderDateWeekly(date, isFrom = false, isFormatYYYYMMDD = false) {
            let [from, to] = date.split('vs')

            if (isFormatYYYYMMDD) {
                if (isFrom) {
                    let [year, month, day] = from.split('-')
                    from = `${day}-${month}-${year}`
                } else {
                    let [year, month, day] = to.split('-')
                    to = `${day}-${month}-${year}`
                }
            }

            return isFrom ? from : to
        },

        renderPrice(price) {
            return formatPrice(price)
        },

        renderSerialNumber() {
            let settings = !isStrEmpty(getSettingDevice()) ? JSON.parse(getSettingDevice()) : ''
            let uniqueId = settings?.uniqueId || ''
            let serial = !isStrEmpty(settings) ? settings.serial.replace('unknown', uniqueId) : '_________'
            return serial
        },
    },
}
</script>
<style lang="scss">
@import '~ThemePath/scss/report-info/_index.scss';
</style>
